import { render, staticRenderFns } from "./SubjectModal.vue?vue&type=template&id=cd4333ba&scoped=true&"
import script from "./SubjectModal.vue?vue&type=script&lang=js&"
export * from "./SubjectModal.vue?vue&type=script&lang=js&"
import style0 from "./SubjectModal.vue?vue&type=style&index=0&id=cd4333ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4333ba",
  null
  
)

export default component.exports